<div class="radio" (click)="toggle()">
  <div class="radio__toggle" [ngClass]="{ active: state}">
    <span class="radio__toggle-marker"></span>
  </div>
  <div class="radio__label">
    <span><ng-content></ng-content></span>
  </div>
</div>